import { Address } from '../enums/checkoutShipping';

class CustomerData {
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    phone: string = '';
    constructor(applePayData) {
        this.firstName = applePayData.billingContact?.givenName;
        this.lastName = applePayData.billingContact?.familyName;
        this.email = applePayData.shippingContact?.emailAddress;
        this.phone = applePayData.shippingContact?.phoneNumber || '';
    }
}

class AddressData {
    firstName: string = '';
    lastName: string = '';
    email: string = '';
    phone: string = '';
    country: string = '';
    city: string = '';
    postalCode: string = '';
    state: string = '';
    streetName: string = '';
    additionalStreetInfo: string = '';
    additionalAddressInfo: string = '';
    title: string = '';
    company: string = '';
    custom: { fields: { phoneExtension: string; loqateInformation: string } };

    constructor(firstName, lastName, customerData, addressData, addressLine1, addressLine2) {
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = customerData.email;
        this.phone = customerData.phone;
        this.country = addressData.countryCode || '';
        this.city = addressData.locality || '';
        this.postalCode = addressData.postalCode || '';
        this.state = addressData.administrativeArea || '';
        this.streetName = addressLine1 || '';
        this.additionalStreetInfo = addressLine2 || '';

        // Order confirmation mail fields
        this.additionalAddressInfo = '';
        this.title = '';
        this.company = '';
        this.custom = {
            fields: {
                phoneExtension: '',
                loqateInformation: `{"addressValidationType":"${Address.APPLE_PAY_VALIDATED}"}`
            }
        };
    }

}

const createAddressData = (firstName, lastName, customerData, addressData) => {
    const [addressLine1, addressLine2] = addressData.addressLines;
    return new AddressData(firstName, lastName, customerData, addressData, addressLine1, addressLine2)
};

const createDataFromApplePayDetails = applePayData => {
    const customerData = new CustomerData(applePayData);
    const firstName = applePayData.shippingContact?.givenName;
    const lastName = applePayData.shippingContact?.familyName;
    let shippingAddressData = createAddressData(firstName, lastName, customerData, applePayData.shippingContact);
    let billingAddressData = createAddressData(customerData.firstName, customerData.lastName, customerData, applePayData.billingContact);
    return { customerData, shippingAddressData, billingAddressData };
};

export default { //eslint-disable-line
    createDataFromApplePayDetails,
};
